module.exports = __webpack_public_path__ + "static/media/zoom-icon.8e4310d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/zoom-icon.svg
// module id = 2875
// module chunks = 0